import { Rule, HTMLarkdownOptions, PassDownOptions, FilterPredicate } from 'htmlarkdown';

export const supFilter: FilterPredicate = (element: Element): boolean => {
    return element.tagName.toLowerCase() === 'sup';
};

export const supRule: Rule = {
    filter: [supFilter],
    replacement: (element: Element, _options: HTMLarkdownOptions, _parentOptions: PassDownOptions): string => {
        const next = element.nextSibling;

        if (
            next?.nodeType === Node.TEXT_NODE &&
            /^\s*\.\s*$/.test(next.textContent ?? '')
        ) {
            next.textContent = '';
        }

        return '';
    }
};
